export type QueueForm={burstUpload:string;burstDownload:string;thresholdUpload:string;thresholdDownload:string;timeUpload:string;timeDownload:string;priority:string;minimumUpload:string;minimumDownload:string};

function decimal(value:number):string{return Number.isFinite(value)?String(Math.round(value*1000)/1000):"";}

export function suggestQueue(upload:string,download:string,percent:string):QueueForm{
  const up=Number(upload),down=Number(download),factor=Math.max(0,Number(percent))/100;
  return{burstUpload:decimal(up*(1+factor)),burstDownload:decimal(down*(1+factor)),thresholdUpload:decimal(up),thresholdDownload:decimal(down),timeUpload:"120",timeDownload:"120",priority:"8",minimumUpload:decimal(Math.max(0,up*(1-factor))),minimumDownload:decimal(Math.max(0,down*(1-factor)))};
}
